import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const ttConfig: TSPConfig = {
  key: 'tt',
  name: 'TT',
  category: TSPCategory.CUSTOM,
  helpText: (
    <ol>
      <li>Login into the TT ELD admin account.</li>
      <li>Click on Settings and then API Keys</li>
      <li>
        Click the 'Generate' button to initiate the API Key creation process.
      </li>
      <li>Input your DOT Number here.</li>
    </ol>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'API Key', name: 'apikey', type: 'text', required: true },
        {
          label: 'Provider Token',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
        {
          label: 'DOT Number',
          name: 'dotnumber',
          type: 'number',
          required: true,
        },
      ]}
    />
  ),
};

export default ttConfig;
